import { put, select, takeLatest } from 'redux-saga/effects'
import { TabConstants } from '../../../components/tabs/Tabs.constants'
import { getPatientTimelineSelector } from '../selectors/patientTimeline.selector'
import { saveTimelineItems, setActivityLog } from '../store/timeline.actions'
import { TimelineConstants } from '../store/timeline.constants'
import { IItem, ITimelineState } from '../store/timeline.types'
import { getTitrateSelector } from '../../procedures/titrate/selectors/titrate.selector'
import { ITitrateState } from '../../procedures/titrate/store/titrate.types'

export function* addTitrateItem() {
  const timeline: ITimelineState = yield select(getPatientTimelineSelector)
  const { items } = timeline
  const titrateState: ITitrateState = yield select(getTitrateSelector)
  const {
    pta,
    addToTimeline,
    medication,
    otherOption,
    route,
    routePNNV,
    key,
    time,
    date,
    assessedBy,
    rate,
    ratePNNV,
    newDose,
    comments,
    isEkgImport,
  } = titrateState
  if (addToTimeline) {
    const index = items.findIndex((item) => item.key === key)
    const dateTime = new Date(date || 0)
    if (time) {
      if (time.split(':').length >= 3) dateTime.setSeconds(+time.split(':')[2])
      dateTime.setMinutes(+time.split(':')[1])
      dateTime.setHours(+time.split(':')[0])
    }
    const item: IItem = {
      key: key,
      grid: true,
      labelHeaderFlag: pta ? 'PTA' : '',
      labelHeader: time,
      subHeader: date,
      itemType: 'Procedures',
      event: 'Titrate',
      eventSubHeader: `By ${assessedBy?.name || ''}, Medication: ${medication ? medication.name : otherOption},
      Route: ${route?.name || routePNNV?.name || ''},
      New Dose/ Rate: ${newDose} ${rate?.name || ratePNNV?.name || ''}, Comments: ${comments}.`,
      rowActionType: TimelineConstants.SET_TITRATE_PROCEDURE_ITEM,
      defaultHref: TabConstants.TITRATE_PROCEDURE,
      date: dateTime,
      ...(isEkgImport && { isEkgImport: isEkgImport }),
    }
    if (index !== -1) {
      items[index] = item
    } else {
      items.push(item)
    }
    yield put(setActivityLog(items))
    yield put(saveTimelineItems())
  }
}

export function* addTitrateItemSaga() {
  yield takeLatest([TimelineConstants.ADD_TITRATE_ITEM], addTitrateItem)
}
